((app, ng) => {

    app.component("insuranceAccount",
        {
            templateUrl: "/App/Client/Case/Accounts/InsuranceAccounts/insurance-account.html",
            controller: insuranceAccountController,
            bindings: {
                client: "<",
                account: "<",
                carriers: "<",
                products: "<",
                advisors: "<",
                currentUser: "<",
                taxQualifications: "<",
                planTypes: "<",
                toggleCollapse: "&",
                onAccountDeleted: "&"
            }
        });

    function insuranceAccountController(annuityAccountApi, carrierProductApi, caseModalService, customFieldApi, FieldStatusesModel, fileViewerModalService, insuranceAccountApi, _insuranceAccountStatuses, lifeAccountApi, longTermCareAccountApi, moment, responseStatus, _states) {
        const $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    saving: false,
                    SurrenderDate: null
                },
                updateCustomField: updateCustomField,
                updateAccount: updateAccount,
                updateProduct: updateProduct,
                updateAccountAdvisors: updateAccountAdvisors,
                getCarrierProducts: getCarrierProducts,
                getLineOfBusiness: getLineOfBusiness,
                openNotes: openNotes,
                openDirectory: openDirectory,
                deleteAccount: deleteAccount
            });

        function updateCustomField(updatedField, fieldIndex) {
            $ctrl.savingStatusForCustomFields.fields[fieldIndex].startSaving();
            $ctrl.ui.saving = true;
            //sanitize custom field entry
            var updateEntry = {
                Id: updatedField.Id,
                CustomFieldId: updatedField.CustomFieldId,
                CaseId: updatedField.CaseId,
                AccountId: updatedField.AccountId,
                TextAnswer: !!updatedField.TextAnswer ? updatedField.TextAnswer : '',
                DateTimeAnswer: !!updatedField.DateTimeAnswer ? new Date(updatedField.DateTimeAnswer) : null,
                TextOptionsAnswerList: null
            };
            return customFieldApi.updateAccountEntry(updateEntry)
                .then((response) => {
                    $ctrl.savingStatusForCustomFields.fields[fieldIndex].succeed();
                    if (!!response) { updatedField.Id = response.Id; }
                })
                .catch((error) => {
                    console.log("Error", error);
                    console.log(updateEntry);
                    $ctrl.savingStatusForCustomFields.fields[fieldIndex].fail();
                })
                .finally(() => { $ctrl.ui.saving = false; });
        }

        function updateAccount(account, editedField) {
            $ctrl.savingStatusAccount.findFieldStatusByName(editedField).startSaving();
            if ($ctrl.ui.SurrenderDate) {
                $ctrl.account.SurrenderDate = new Date($ctrl.ui.SurrenderDate);
            }
            insuranceAccountApi.update(account.InsuranceAccountId, account)
                .then(() => {
                    $ctrl.savingStatusAccount.findFieldStatusByName(editedField).succeed();
                }).catch(() => {
                    $ctrl.savingStatusAccount.findFieldStatusByName(editedField).fail();
                });

            if (account.AnnuityAccountId) {
                annuityAccountApi.update(account.AnnuityAccountId, account)
                    .then(() => {
                        $ctrl.savingStatusAccount.findFieldStatusByName(editedField).succeed();
                    }).catch(() => {
                        $ctrl.savingStatusAccount.findFieldStatusByName(editedField).fail();
                    });
            }

            if (account.LifeAccountId) {
                lifeAccountApi.update(account.LifeAccountId, account)
                    .then(() => {
                        $ctrl.savingStatusAccount.findFieldStatusByName(editedField).succeed();
                    }).catch(() => {
                        $ctrl.savingStatusAccount.findFieldStatusByName(editedField).fail();
                    });
            }

            if (account.LongTermCareAccountId) {
                longTermCareAccountApi.update(account.LongTermCareAccountId, account)
                    .then(() => {
                        $ctrl.savingStatusAccount.findFieldStatusByName(editedField).succeed();
                    }).catch(() => {
                        $ctrl.savingStatusAccount.findFieldStatusByName(editedField).fail();
                    });
            }
        }

        function updateProduct(account) {
            insuranceAccountApi.updateCarrierProduct(account.InsuranceAccountId, account);
        }

        function updateAccountAdvisors(accountId, advisorId, accountAdvisors) {
            const index = accountAdvisors.findIndex(advisor => advisor.Id === advisorId);

            index === -1
                ? insuranceAccountApi.addAdvisor(accountId, advisorId)
                : insuranceAccountApi.removeAdvisor(accountId, advisorId);
        }

        function getCarrierProducts(carrierId) {
            const hasProducts = $ctrl.products.some(product => product.CarrierId === carrierId);

            if (!hasProducts) {
                carrierProductApi.getProductsPerCarrier(carrierId).then(response => {
                    $ctrl.products = [...$ctrl.products, ...response];
                });
            }
        }

        function getLineOfBusiness(account) {
            if (!!account.LifeAccountId) return "Life";
            if (!!account.AnnuityAccountId) return "Annuity";
            if (!!account.LongTermCareAccountId) return "Long Term Care";
            if (!!account.MedicareAccountId) return "Medicare";

            return "Unknown";
        }

        function deleteAccount(accountId) {
            caseModalService.confirmAccountDeletion().then(() => {
                $ctrl.onAccountDeleted({ accountId });

                insuranceAccountApi.delete(accountId);
            });
        }

        function openNotes($event) {
            caseModalService.openInsuranceAccountNotes($ctrl.account.InsuranceAccountId, $ctrl.currentUser, $event);
        }

        function openDirectory($event) {
            fileViewerModalService.openInsuranceAccountDirectory($ctrl.account.InsuranceAccountId,
                $ctrl.currentUser,
                $ctrl.client,
                $event);
        }

        $ctrl.$onInit = () => {
            $ctrl.ui.SurrenderDate = $ctrl.account.SurrenderDate ? moment.utc($ctrl.account.SurrenderDate).format("L") : null;
            $ctrl.insuranceAccountStatuses = _insuranceAccountStatuses;
            $ctrl.states = _states;
            $ctrl.selectedCarrierId = $ctrl.account.CarrierProduct.CarrierId;
            $ctrl.getCarrierProducts($ctrl.selectedCarrierId);
            $ctrl.savingStatusAccount = new FieldStatusesModel($ctrl.account);
            $ctrl.savingStatusForCustomFields = new FieldStatusesModel($ctrl.account.CustomFields);
            $ctrl.responseStatus = responseStatus;
            _.forEach($ctrl.account.CustomFields, (field) => {
                if (field.CustomFieldType === 'DateTime') {
                    field.AccountEntryModel.DateTimeAnswer = field.AccountEntryModel.DateTimeAnswer ? moment.utc(field.AccountEntryModel.DateTimeAnswer).format("L") : null;
                }
            });
        }
    }

})(window.app, window.angular);